import { useMatrix } from '@/core/domain/enterprise/Matrix/Matrix.hooks';
import { ACCESS_TOKEN } from '@/utils/user/constants';
import { useEffect } from 'react';

export default function ChatAI() {
  const { data: matrix } = useMatrix();

  useEffect(() => {
    if (!matrix?.matrixSettings.isChatSupportEnabled) return;

    const qiggerConfigScript = document.createElement('script');
    qiggerConfigScript.innerHTML = `window.QiggerChatConfig = {
      apiBaseUrl: '${process.env.REACT_APP_API_URL}/chat-api/v1/',
      widgetUrl: 'https://storageultracarsupportai.blob.core.windows.net/chat-files/widget.js'
    };`;

    const loaderIIFEScript = document.createElement('script');
    loaderIIFEScript.src =
      'https://storageultracarsupportai.blob.core.windows.net/chat-files/loader.iife.js';
    loaderIIFEScript.crossOrigin = 'anonymous';

    const ensureInit = (tries = 10) => {
      const tick = () => {
        const q = window.QiggerChat;
        if (
          q &&
          typeof q.isInitialized === 'function' &&
          typeof q.init === 'function'
        ) {
          if (!q.isInitialized()) q.init();
          return;
        }
        if (tries-- > 0) setTimeout(tick, 100);
      };
      tick();
    };

    const mountWidget = () => {
      const hasAccessToken = !!localStorage.getItem(ACCESS_TOKEN);

      if (hasAccessToken) {
        document.body.append(qiggerConfigScript, loaderIIFEScript);

        ensureInit();
      }
    };

    const unmoutWidget = () => {
      qiggerConfigScript?.remove();
      loaderIIFEScript?.remove();
      document.getElementById('qigger-chat-widget')?.remove();
    };

    const onStorage = (e: StorageEvent) => {
      if (e.storageArea?.getItem(ACCESS_TOKEN)) {
        mountWidget();
      } else {
        unmoutWidget();
      }
    };

    mountWidget();

    window.addEventListener('DOMContentLoaded', mountWidget);
    window.addEventListener('USER_LOGOUT', unmoutWidget);
    window.addEventListener('storage', onStorage);

    return () => {
      window.removeEventListener('USER_LOGGED', mountWidget);
      window.removeEventListener('USER_LOGOUT', unmoutWidget);
      window.removeEventListener('storage', onStorage);
    };
  }, [matrix?.matrixSettings.isChatSupportEnabled]);

  return null;
}
